import React from 'react'
import { node } from 'prop-types'
import { StackView, Box } from '@planningcenter/tapestry-react'

const ContentWrapper = ({ children, ...props }) => {
  return (
    <StackView
      axis="vertical"
      alignment="center"
      distribution="start"
      column={1}
      row={2}
      padding={4}
      maxHeight="100vh"
      overflow="scroll"
      background="#fff"
      mediaQueries={{
        lg: {
          column: 2,
        },
      }}
      {...props}
    >
      <Box width="100%">{children}</Box>
    </StackView>
  )
}

ContentWrapper.propTypes = {
  children: node,
}

export default ContentWrapper
